// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * 팝업 창(모달) 공통 모양 — 제목줄 · 제목 · 닫기 · 버튼.
 *
 * 기준은 튜닝 사례 · 테이블 분석 창(assistant/TuningCaseModal.css)이다. 모니터링 메뉴의 창들이
 * 창마다 접두어(dynview-, resana-, sessadm- …)로 제목 크기·닫기 아이콘·버튼을 따로 칠해
 * 한 앱 안에서 창마다 모양이 달랐다(사용자 요청 2026-09-13).
 *
 * 쓰는 법 — 창의 뿌리 요소에 class "app-modal" 과 속성 data-app-modal 을 붙이고:
 *   제목줄  app-modal-header        제목  app-modal-title (아이콘 14px + 글자)
 *   닫기    app-modal-close (FiX 16px, 제목줄 맨 오른쪽)
 *   제목줄 아이콘 버튼  app-modal-iconbtn
 *   버튼    app-btn / 주 동작 app-btn app-btn-primary
 *
 * **선택자를 일부러 세게 쓴다**(.app-modal[data-app-modal] …). 창마다의 옛 CSS 를 지우지 않고도
 * 여기가 이기게 하려는 것이다 — 옛 규칙은 제목줄 기준 선택자 3단계 이하, !important 없음(2026-09-13 조사).
 * 창 크기 · 전체화면 · 본문 배치는 **다루지 않는다**(창마다 필요가 다르다).
 * 규칙과 새 창 체크리스트: docs/ui-modal-consistency.md
 */

/* ── 제목줄 ── */
.app-modal[data-app-modal] .app-modal-header.app-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 16px;
  min-height: 0;
  background: #f8f9fa;
  color: inherit;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}
[data-theme="dark"] .app-modal[data-app-modal] .app-modal-header.app-modal-header {
  background: #252526;
  border-bottom-color: #333;
}

/* ── 제목 ── */
.app-modal[data-app-modal] .app-modal-title.app-modal-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  color: inherit;
  white-space: nowrap;
}
.app-modal[data-app-modal] .app-modal-title.app-modal-title > svg {
  flex-shrink: 0;
}

/* ── 닫기 / 제목줄 아이콘 버튼 ── */
.app-modal[data-app-modal] .app-modal-close.app-modal-close,
.app-modal[data-app-modal] .app-modal-iconbtn.app-modal-iconbtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: auto;
  margin: 0;
  padding: 2px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: inherit;
  opacity: 1;
  cursor: pointer;
  transition: background-color 150ms ease;
}
.app-modal[data-app-modal] .app-modal-close.app-modal-close:hover,
.app-modal[data-app-modal] .app-modal-iconbtn.app-modal-iconbtn:hover:not(:disabled) {
  background: rgba(127, 127, 127, 0.15);
  color: inherit;
}
.app-modal[data-app-modal] .app-modal-iconbtn.app-modal-iconbtn:disabled {
  opacity: 0.45;
  cursor: default;
}

/* ── 버튼 ── */
.app-modal[data-app-modal] .app-btn.app-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: normal;
  line-height: 1.2;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: transparent;
  color: inherit;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: none;
  transition: background-color 150ms ease, border-color 150ms ease;
}
.app-modal[data-app-modal] .app-btn.app-btn:hover:not(:disabled) {
  background: rgba(127, 127, 127, 0.14);
  color: inherit;
}
.app-modal[data-app-modal] .app-btn.app-btn:disabled {
  opacity: 0.45;
  cursor: default;
}
.app-modal[data-app-modal] .app-btn.app-btn-primary {
  border-color: #6aa3e0;
  color: #2f6fb0;
  font-weight: 600;
}
.app-modal[data-app-modal] .app-btn.app-btn-primary:hover:not(:disabled) {
  background: rgba(106, 163, 224, 0.16);
  color: #2f6fb0;
}
/* 삭제처럼 되돌릴 수 없는 동작 — 창마다의 빨간 버튼을 공통 버튼 모양이 덮지 않게 */
.app-modal[data-app-modal] .app-btn.app-btn-danger {
  border-color: #e0a3a3;
  color: #c0392b;
}
.app-modal[data-app-modal] .app-btn.app-btn-danger:hover:not(:disabled) {
  background: rgba(192, 57, 43, 0.1);
  color: #c0392b;
}
[data-theme="dark"] .app-modal[data-app-modal] .app-btn.app-btn {
  border-color: #444;
}
[data-theme="dark"] .app-modal[data-app-modal] .app-btn.app-btn-danger {
  border-color: #7a3b3b;
  color: #ff8a80;
}
[data-theme="dark"] .app-modal[data-app-modal] .app-btn.app-btn-danger:hover:not(:disabled) {
  color: #ff8a80;
}
[data-theme="dark"] .app-modal[data-app-modal] .app-btn.app-btn-primary {
  border-color: #4a7fb5;
  color: #8fbdea;
}
[data-theme="dark"] .app-modal[data-app-modal] .app-btn.app-btn-primary:hover:not(:disabled) {
  color: #8fbdea;
}

/* ── 제목 바로 오른쪽 (AppModal titleExtra) — 남은 폭을 차지한다. 오라클 전문가 창의 DB 연결 탭(2026-10-22) ── */
.app-modal[data-app-modal] .app-modal-title-extra {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  margin-left: 8px;
}

/* ── 제목줄 오른쪽 묶음 (AppModal) — 창 조작 + 닫기 ── */
.app-modal[data-app-modal] .app-modal-header-right {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
}

/* 열릴 때 창에 포커스를 옮긴다(Esc 가 바로 먹게). 마우스로 연 사람에게 테두리가 보이면 거슬린다 */
.app-modal[data-app-modal]:focus {
  outline: none;
}

/* ── AppModal 기본 틀 ──
   :where() 로 선택자 세기를 0 으로 둔다 — 창이 자기 클래스(overlayClassName/className)를 넘기면 그쪽이
   늘 이긴다. 창 틀 기본값은 **className 을 안 준 창**(app-modal-default)에만 건다: app-modal 에 걸면
   이미 이 클래스를 쓰는 기존 창들의 크기가 바뀐다. */
:where(.app-modal-overlay) {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  animation: app-modal-fade 160ms ease-out;
}
:where(.app-modal-default) {
  display: flex;
  flex-direction: column;
  width: min(calc(92vw / var(--app-zoom, 1)), 960px);
  max-height: calc(88vh / var(--app-zoom, 1));
  overflow: hidden;
  background: #fff;
  color: #222;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  animation: app-modal-rise 180ms ease-out;
}
:where([data-theme="dark"]) :where(.app-modal-default) {
  background: #1e1e1e;
  color: #ddd;
}
@keyframes app-modal-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes app-modal-rise {
  from { opacity: 0; transform: translateY(-3px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .app-modal[data-app-modal] .app-modal-close.app-modal-close,
  .app-modal[data-app-modal] .app-modal-iconbtn.app-modal-iconbtn,
  .app-modal[data-app-modal] .app-btn.app-btn {
    transition: none;
  }
  :where(.app-modal-overlay),
  :where(.app-modal-default) {
    animation: none;
  }
}

/* ── 창처럼(windowed — useModalWindow, 2026-10-06): 끌어서 이동 · 최대화 · 새 창으로 분리 ── */
.app-modal[data-app-modal] [data-win-drag="true"] { cursor: move; -webkit-user-select: none; user-select: none; }
.app-modal[data-app-modal] [data-win-drag="true"] :is(button, input, select, textarea, a, label) { cursor: auto; }
.app-modal[data-app-modal] [data-win-drag="true"] button { cursor: pointer; }
/* 창 조작 단추(최대화·새 창) — 서로 6px, 왼쪽 단추 묶음과 닫기(X)에서는 한 칸 더 띄우고 닫기 앞에 옅은 구분선(사용자 요청 2026-10-11).
   제목줄 묶음의 gap(8px) 위에 더한다 — 창마다 따로 띄우지 말고 여기 한 곳에서 */
.modal-win-controls { display: inline-flex; align-items: center; gap: 6px; margin: 0 4px 0 6px; padding-right: 10px;
  border-right: 1px solid var(--color-border, #e5e7eb); }

/* 고정폭 글(실행계획 표 등)의 넓은 글자(한글 등)를 정확히 2칸으로 — utils/monoWide.monoWideText. 고정폭 글꼴에 한글이 없으면
   대체 글꼴의 한글이 2칸보다 넓어 한글이 든 줄만 뒤가 밀린다(실행계획 탭의 .wideCh 와 같은 규칙) */
.mono-wide {
  display: inline-block;
  width: 2ch;
  text-align: center;
  overflow: hidden;
  vertical-align: bottom;
}
`, "",{"version":3,"sources":["webpack://./src/styles/appModal.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;EAiBE;;AAEF,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,eAAe;EACf,uCAAuC;AACzC;AACA;;EAEE,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gEAAgE;AAClE;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;AACA,mDAAmD;AACnD;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,uFAAuF;AACvF;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;AACf;;AAEA;;;iCAGiC;AACjC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kDAAkD;EAClD,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,wCAAwC;AAC1C;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;EACA;;IAEE,eAAe;EACjB;AACF;;AAEA,8EAA8E;AAC9E,oDAAoD,YAAY,EAAE,yBAAiB,EAAjB,iBAAiB,EAAE;AACrF,mGAAmG,YAAY,EAAE;AACjH,2DAA2D,eAAe,EAAE;AAC5E;qDACqD;AACrD,sBAAsB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE,mBAAmB;EACjH,oDAAoD,EAAE;;AAExD;gEACgE;AAChE;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":["/*\r\n * 팝업 창(모달) 공통 모양 — 제목줄 · 제목 · 닫기 · 버튼.\r\n *\r\n * 기준은 튜닝 사례 · 테이블 분석 창(assistant/TuningCaseModal.css)이다. 모니터링 메뉴의 창들이\r\n * 창마다 접두어(dynview-, resana-, sessadm- …)로 제목 크기·닫기 아이콘·버튼을 따로 칠해\r\n * 한 앱 안에서 창마다 모양이 달랐다(사용자 요청 2026-09-13).\r\n *\r\n * 쓰는 법 — 창의 뿌리 요소에 class \"app-modal\" 과 속성 data-app-modal 을 붙이고:\r\n *   제목줄  app-modal-header        제목  app-modal-title (아이콘 14px + 글자)\r\n *   닫기    app-modal-close (FiX 16px, 제목줄 맨 오른쪽)\r\n *   제목줄 아이콘 버튼  app-modal-iconbtn\r\n *   버튼    app-btn / 주 동작 app-btn app-btn-primary\r\n *\r\n * **선택자를 일부러 세게 쓴다**(.app-modal[data-app-modal] …). 창마다의 옛 CSS 를 지우지 않고도\r\n * 여기가 이기게 하려는 것이다 — 옛 규칙은 제목줄 기준 선택자 3단계 이하, !important 없음(2026-09-13 조사).\r\n * 창 크기 · 전체화면 · 본문 배치는 **다루지 않는다**(창마다 필요가 다르다).\r\n * 규칙과 새 창 체크리스트: docs/ui-modal-consistency.md\r\n */\r\n\r\n/* ── 제목줄 ── */\r\n.app-modal[data-app-modal] .app-modal-header.app-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  min-height: 0;\r\n  background: #f8f9fa;\r\n  color: inherit;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  flex-shrink: 0;\r\n}\r\n[data-theme=\"dark\"] .app-modal[data-app-modal] .app-modal-header.app-modal-header {\r\n  background: #252526;\r\n  border-bottom-color: #333;\r\n}\r\n\r\n/* ── 제목 ── */\r\n.app-modal[data-app-modal] .app-modal-title.app-modal-title {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  margin: 0;\r\n  min-width: 0;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  line-height: 1.3;\r\n  color: inherit;\r\n  white-space: nowrap;\r\n}\r\n.app-modal[data-app-modal] .app-modal-title.app-modal-title > svg {\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ── 닫기 / 제목줄 아이콘 버튼 ── */\r\n.app-modal[data-app-modal] .app-modal-close.app-modal-close,\r\n.app-modal[data-app-modal] .app-modal-iconbtn.app-modal-iconbtn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: auto;\r\n  height: auto;\r\n  margin: 0;\r\n  padding: 2px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: inherit;\r\n  opacity: 1;\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease;\r\n}\r\n.app-modal[data-app-modal] .app-modal-close.app-modal-close:hover,\r\n.app-modal[data-app-modal] .app-modal-iconbtn.app-modal-iconbtn:hover:not(:disabled) {\r\n  background: rgba(127, 127, 127, 0.15);\r\n  color: inherit;\r\n}\r\n.app-modal[data-app-modal] .app-modal-iconbtn.app-modal-iconbtn:disabled {\r\n  opacity: 0.45;\r\n  cursor: default;\r\n}\r\n\r\n/* ── 버튼 ── */\r\n.app-modal[data-app-modal] .app-btn.app-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 4px;\r\n  padding: 4px 10px;\r\n  font-size: 11px;\r\n  font-weight: normal;\r\n  line-height: 1.2;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: inherit;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n  box-shadow: none;\r\n  transition: background-color 150ms ease, border-color 150ms ease;\r\n}\r\n.app-modal[data-app-modal] .app-btn.app-btn:hover:not(:disabled) {\r\n  background: rgba(127, 127, 127, 0.14);\r\n  color: inherit;\r\n}\r\n.app-modal[data-app-modal] .app-btn.app-btn:disabled {\r\n  opacity: 0.45;\r\n  cursor: default;\r\n}\r\n.app-modal[data-app-modal] .app-btn.app-btn-primary {\r\n  border-color: #6aa3e0;\r\n  color: #2f6fb0;\r\n  font-weight: 600;\r\n}\r\n.app-modal[data-app-modal] .app-btn.app-btn-primary:hover:not(:disabled) {\r\n  background: rgba(106, 163, 224, 0.16);\r\n  color: #2f6fb0;\r\n}\r\n/* 삭제처럼 되돌릴 수 없는 동작 — 창마다의 빨간 버튼을 공통 버튼 모양이 덮지 않게 */\r\n.app-modal[data-app-modal] .app-btn.app-btn-danger {\r\n  border-color: #e0a3a3;\r\n  color: #c0392b;\r\n}\r\n.app-modal[data-app-modal] .app-btn.app-btn-danger:hover:not(:disabled) {\r\n  background: rgba(192, 57, 43, 0.1);\r\n  color: #c0392b;\r\n}\r\n[data-theme=\"dark\"] .app-modal[data-app-modal] .app-btn.app-btn {\r\n  border-color: #444;\r\n}\r\n[data-theme=\"dark\"] .app-modal[data-app-modal] .app-btn.app-btn-danger {\r\n  border-color: #7a3b3b;\r\n  color: #ff8a80;\r\n}\r\n[data-theme=\"dark\"] .app-modal[data-app-modal] .app-btn.app-btn-danger:hover:not(:disabled) {\r\n  color: #ff8a80;\r\n}\r\n[data-theme=\"dark\"] .app-modal[data-app-modal] .app-btn.app-btn-primary {\r\n  border-color: #4a7fb5;\r\n  color: #8fbdea;\r\n}\r\n[data-theme=\"dark\"] .app-modal[data-app-modal] .app-btn.app-btn-primary:hover:not(:disabled) {\r\n  color: #8fbdea;\r\n}\r\n\r\n/* ── 제목 바로 오른쪽 (AppModal titleExtra) — 남은 폭을 차지한다. 오라클 전문가 창의 DB 연결 탭(2026-10-22) ── */\r\n.app-modal[data-app-modal] .app-modal-title-extra {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  margin-left: 8px;\r\n}\r\n\r\n/* ── 제목줄 오른쪽 묶음 (AppModal) — 창 조작 + 닫기 ── */\r\n.app-modal[data-app-modal] .app-modal-header-right {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-left: auto;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* 열릴 때 창에 포커스를 옮긴다(Esc 가 바로 먹게). 마우스로 연 사람에게 테두리가 보이면 거슬린다 */\r\n.app-modal[data-app-modal]:focus {\r\n  outline: none;\r\n}\r\n\r\n/* ── AppModal 기본 틀 ──\r\n   :where() 로 선택자 세기를 0 으로 둔다 — 창이 자기 클래스(overlayClassName/className)를 넘기면 그쪽이\r\n   늘 이긴다. 창 틀 기본값은 **className 을 안 준 창**(app-modal-default)에만 건다: app-modal 에 걸면\r\n   이미 이 클래스를 쓰는 기존 창들의 크기가 바뀐다. */\r\n:where(.app-modal-overlay) {\r\n  position: fixed;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  z-index: 1001;\r\n  animation: app-modal-fade 160ms ease-out;\r\n}\r\n:where(.app-modal-default) {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: min(calc(92vw / var(--app-zoom, 1)), 960px);\r\n  max-height: calc(88vh / var(--app-zoom, 1));\r\n  overflow: hidden;\r\n  background: #fff;\r\n  color: #222;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\r\n  animation: app-modal-rise 180ms ease-out;\r\n}\r\n:where([data-theme=\"dark\"]) :where(.app-modal-default) {\r\n  background: #1e1e1e;\r\n  color: #ddd;\r\n}\r\n@keyframes app-modal-fade {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n@keyframes app-modal-rise {\r\n  from { opacity: 0; transform: translateY(-3px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .app-modal[data-app-modal] .app-modal-close.app-modal-close,\r\n  .app-modal[data-app-modal] .app-modal-iconbtn.app-modal-iconbtn,\r\n  .app-modal[data-app-modal] .app-btn.app-btn {\r\n    transition: none;\r\n  }\r\n  :where(.app-modal-overlay),\r\n  :where(.app-modal-default) {\r\n    animation: none;\r\n  }\r\n}\r\n\r\n/* ── 창처럼(windowed — useModalWindow, 2026-10-06): 끌어서 이동 · 최대화 · 새 창으로 분리 ── */\r\n.app-modal[data-app-modal] [data-win-drag=\"true\"] { cursor: move; user-select: none; }\r\n.app-modal[data-app-modal] [data-win-drag=\"true\"] :is(button, input, select, textarea, a, label) { cursor: auto; }\r\n.app-modal[data-app-modal] [data-win-drag=\"true\"] button { cursor: pointer; }\r\n/* 창 조작 단추(최대화·새 창) — 서로 6px, 왼쪽 단추 묶음과 닫기(X)에서는 한 칸 더 띄우고 닫기 앞에 옅은 구분선(사용자 요청 2026-10-11).\r\n   제목줄 묶음의 gap(8px) 위에 더한다 — 창마다 따로 띄우지 말고 여기 한 곳에서 */\r\n.modal-win-controls { display: inline-flex; align-items: center; gap: 6px; margin: 0 4px 0 6px; padding-right: 10px;\r\n  border-right: 1px solid var(--color-border, #e5e7eb); }\r\n\r\n/* 고정폭 글(실행계획 표 등)의 넓은 글자(한글 등)를 정확히 2칸으로 — utils/monoWide.monoWideText. 고정폭 글꼴에 한글이 없으면\r\n   대체 글꼴의 한글이 2칸보다 넓어 한글이 든 줄만 뒤가 밀린다(실행계획 탭의 .wideCh 와 같은 규칙) */\r\n.mono-wide {\r\n  display: inline-block;\r\n  width: 2ch;\r\n  text-align: center;\r\n  overflow: hidden;\r\n  vertical-align: bottom;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
